import { Breadcrumb, MetaTitle } from "@/types/Facet";

export function useBreadcrumbsAndJsonld() {
  const route = useRoute();
  const config = useRuntimeConfig();
  const metaTitle: MetaTitle = useState("metaTitle");
  // パンくず設定用
  const breadcrumbs: Array<Breadcrumb> = [
    {
      url: `${config.public.fireBangDomainName}`,
      text: "bang! 火災保険トップ",
    },
    {
      url: `${config.public.fireBangDomainName}` + `${route.path}`,
      text: `${metaTitle.value}`,
    },
  ];
  const items = breadcrumbs.map((item: Breadcrumb, index: number) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.text,
    item: item.url,
  }));
  // 構造化データ登録用
  useJsonld(() => ({
    "@context": "https://schema.org",
    "@type": "Thing",
    BreadcrumbList: {
      "@type": "BreadcrumbList",
      itemListElement: items,
    },
  }));
  return {
    breadcrumbs,
  };
}
